import React, { useState } from "react";
import {
    Container,
    Flex,
    Box,
    Heading,
    Text,
    IconButton,
    Button,
    VStack,
    HStack,
    Wrap,
    WrapItem,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    InputLeftElement,
    Textarea,
    Link
} from "@chakra-ui/react";
import {
    MdPhone,
    MdEmail,
    MdLocationOn,
    MdFacebook,
    MdOutlineEmail,
} from "react-icons/md";
import { BsGithub, BsDiscord, BsPerson } from "react-icons/bs";
import { send } from "emailjs-com";
import { useToast } from "@chakra-ui/react";
import { COLORS } from "../../../colors";

export const FormContactSmall = ({ close }) => {

    const [fromName, setFromName] = useState("");
    const [toName, setToName] = useState("");
    const [message, setMessage] = useState("");
    const [replyTo, setReplyTo] = useState("");
    const toast = useToast();

    const onSubmit = (e) => {
        const toSend = {
            from_name: fromName,
            to_name: "valenciaivan21@gmail.com",
            message: message,
            reply_to: replyTo,
        };
        send(
            process.env.REACT_APP_SERVICE_ID,
            process.env.REACT_APP_TEMPLATE_ID,
            toSend,
            process.env.REACT_APP_USER_ID
        )
            .then((response) => {
                close();
                toast({
                    title: "OK",
                    description: "Has enviado el correo electrónico",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });
            })
            .catch((err) => {
                console.log("FAILED...", err);
            });
    };

    return (
        <Flex flexDirection={'column'} gap={10} m={50}>
            
                <Button                
                    //to="mailto:info@somersetlc.com"
                    size={"md"}
                    fontWeight={"normal"}
                    px={6}
                    border={`2px solid ${COLORS.brand1}`}
                    bg={COLORS.brand5}
                    color={COLORS.brand1}
                    _hover={{ bg: COLORS.brand1, color: COLORS.brand5}}
                    fontFamily={"Montserrat"}
                    onClick={() => window.location.href = 'mailto:info@somersetlc.com'}
                    

                >
                    Contactar por e-mail
                </Button>
            
            <Button           
                onClick={() => window.location.href = "https://api.whatsapp.com/send?phone=601129552"}
                size={"md"}
                fontWeight={"normal"}
                px={6}
                border={`2px solid ${COLORS.brand1}`}
                bg={COLORS.brand5}
                color={COLORS.brand1}
                _hover={{ bg: COLORS.brand1, color: COLORS.brand5}}
                fontFamily={"Montserrat"}
            >
                Contactar por Whatsapp
            </Button>
      </Flex>
      
      /*  <Box bg="white" borderRadius="lg">
            <Text ml={7} mt={5} fontSize={{ base: 18, md: 24 }} fontFamily={"Montserrat"}>
                Envíanos un correo:
            </Text>
            <Box m={8} color="#0B0E3F" fontFamily={"Montserrat"}>
                <VStack spacing={5}>
                    <FormControl id="name">
                        <FormLabel fontSize={{ base: 14, md: 16 }}>Nombre</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                            <Input
                                placeholder="Nombre"
                                type="text"
                                size="md"
                                onChange={(e) => setFromName(e.target.value)}
                            />
                        </InputGroup>
                    </FormControl>
                    <FormControl id="name">
                        <FormLabel fontSize={{ base: 14, md: 16 }}>Correo electrónico</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                            <Input
                                placeholder="Correo eléctrónico"
                                type="text"
                                size="md"
                                onChange={(e) => setReplyTo(e.target.value)}
                            />
                        </InputGroup>
                    </FormControl>
                    <FormControl id="name">
                        <FormLabel fontSize={{ base: 14, md: 16 }}>Mensaje</FormLabel>
                        <Textarea
                            borderColor="gray.300"
                            _hover={{
                                borderRadius: "gray.300",
                            }}
                            placeholder="Mensaje"
                            onChange={(e) => setMessage(e.target.value)}
                        />
                    </FormControl>
                    <FormControl id="name" float="right">
                        <Button
                            variant="solid"
                            bg={COLORS.brand1}
                            color={COLORS.brand4}
                            _hover={{ bg: COLORS.brand3, color: COLORS.brand1}}
                            onClick={onSubmit}
                        >
                            Enviar
                        </Button>
                    </FormControl>
                </VStack>
            </Box>
        </Box>   */
    );
};
